import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    roomGrid: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    room: {
        //paddingBottom:20
    },
    chartTitle: {
        marginBottom: 0,
        paddingLeft: 24,
        fontWeight: 'bold'
    },
    chartMargin: {
        marginTop:-30
    }
}));

function SaleRoomChart(props) {
    const roomNo = props.roomData.roomNo;
    const qtySold = props.roomData.qtySold;
    const qtyUnsold = props.roomData.qtyUnsold;

    let qtyWD = props.roomData.qtyWD;
    if (qtyWD === null || isNaN(qtyWD))
        qtyWD = 0;

    const qtyTotal = props.roomData.qtyTotal;
    const qtyTotalOffered = props.roomData.qtyTotalOffered;
    const qtyPI = props.roomData.qtyPI;

    let qtyPIPerc = ((props.roomData.qtyPI / (props.roomData.qtyTotalOffered = 0 ? 1 : props.roomData.qtyTotalOffered)) * 100).toFixed(1);
    if (isNaN(qtyPIPerc))
        qtyPIPerc = 0;

    const maxValue = props.maxLots;

    const series = [{
        name: 'Sold lots',
        data: [qtySold]

    }, {
        name: 'Unsold lots',
        data: [qtyUnsold]
    }];
    const options = {
        chart: {
            stacked: true,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                //colors: {
                //    backgroundBarColors: ['#f1f1f2'],
                //    backgroundBarOpacity: 1,
                //}
            },

        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: 14
            }
        },
        grid: {
            show: true,
            //row: {
            //    colors: ['#f1f1f2'],
            //    opacity: 0.5
            //},
            column: {
                colors: ['#f1f1f2'],
                opacity: 0.2
            },
            borderColor: "#bcbec0",
            position: 'back',
            xaxis: {
                lines: {
                    show: true
                }
            }
        },
        legend: {
            show: false
        },

        title: {
            text: undefined
        },
        xaxis: {
            categories: [''],
        },
        yaxis: {
            title: {
                text: undefined
            },
            min: 0,
            max: maxValue,
            forceNiceScale: true
        },
        fill: {
            opacity: 1
        },
        colors: ['#75c152', '#f3723a'],
    };
    const classes = useStyles();

    return (
        <Grid container spacing={0}>
            <Grid item xs={2} className={classes.roomGrid}>
                <div>              
                    <p><strong>WD: {qtyWD}</strong><br />
                    </p>
                    <p><strong>PI: {qtyPIPerc} %</strong><br/>                        
                    </p>
                </div>
            </Grid>
            <Grid item xs={9}>
                <div id="chart">
                    <div className={classes.chartTitle}>Room {roomNo}</div>
                    <ReactApexChart className={classes.chartMargin}  options={options} series={series} type="bar" height="150" />
                </div>
            </Grid>
            <Grid item xs={1}>
            </Grid>
        </Grid>
    )
}
export default SaleRoomChart;
